export const API_ENDPOINTS = {
  LOGIN: "/login",
  CURRENT_USER: "/currentuser",
  ACCOUNT_SETTING: "/accountsetting",
  ACCOUNTS: "/accounts",
  RESET_PASS: "/resetpass",
  ACCOUNT_PASSWORD: "/account/password",
  CONFIRM_EMAIL: "/account/confirm-email",
  ACCOUNT: "/account",
  CHAINS: "/chains",
  DELETE_ACCOUNT:"/delete",
  STORES: "/stores",
  ACCOUNT_IN_STORES: "/store/accounts",
  PASSWORD_HISTORIES: "/passwordhistories",
  LIST_OTA: "/otas",
  OTA_ACCOUNTS: "otaaccounts",
  STORE_SEARCH: "/store/search",
  CHAIN_SEARCH: "/chains/search",
  CHAIN: "/chain",
  DELETE_CHAIN: "/chain/delete",
  DIRECTORS: "/directors",
  SITE_CONTROLLERS: "/sitecontrollers",
  STORE: "/store",
  ALL_STORES: "/store/all",
  LIST_DIRECTORS: "/listdirectors/{currentDirector}",
  SELECT_STORES: "/selectstores",
  TASKS_SEARCH: "/tasks/search",
  TASKS_GANTT_CHART: "/tasks/taskGanttChart",
  LIST_USERS: "/listusers",
  LIST_REGISTERS: "/listregisters",
  TASK_ATTACH_UPLOAD: "/tasks/attach/upload",
  TASK_ATTACH_UPLOAD_BY_SUB_CATEGORY: "/tasks/{taskId}/attach/upload-by-sub-category",
  TASK_ATTACH_DOWNLOAD: "/tasks/{taskId}/attach/download?attachId=",
  TASK_ATTACH_PRESIGNED_URL: "/tasks/{taskId}/attach/{attachId}/presigned-url",
  TASK_ATTACH_DELETE: "/tasks/{taskId}/attach/{taskAttachId}/type/{typeAttach}",
  TASK_ATTACH_FILE_NOTE: "/tasks/attach/upload-file-note",
  GET_TASK_ATTACH_FILE_NOTE: "/tasks/attach/get-file-notes/{taskId}",
  DELETE_TASK_ATTACH_FILE_NOTE: "/tasks/{taskId}/attach/delete-file-note/{taskAttachId}",
  DOWNLOAD_TASK_ATTACH_FILE_NOTE: "/tasks/attach/download-file-note/{taskAttachId}",
  TASK_TASKLOGS: "/tasks/{taskId}/tasklogs",
  TASK_TASKLOG_SUMMARIES: "/tasks/{taskId}/usertasksummaries",
  TASK: "/task",
  TASKS: "/tasks",
  TASK_CATEGORIES: "/tasks/{taskId}/categories",
  CATEGORIES: "/categories",
  GET_CATEGORY: "/get-category",
  CATEGORIES_MULTI: "/categories/multi",
  TASK_COMMENTS: "/tasks/{taskId}/comments",
  USERS_MENTION_TASK: "tasks/{taskId}/usermentions",
  ADD_COMMENTS: "/comment",
  EDIT_COMMENT: "/editcomment/{commentId}",
  USERS: "/users",
  TASK_CHILDREN: "/tasks/{taskId}/childs",
  TASK_TASKLOGS_LATEST: "/tasks/{taskId}/tasklogs/latest",
  TASK_STOPWATCH: "/tasks/{taskId}/stopwatch",
  TASK_TOTAL_TIMES: "/tasks/{taskId}/totaltimes",
  TASK_EDIT_TASKLOG: "/tasks/{taskId}/tasklogs/{taskLogId}",
  TASK_EDIT_STATUS: "/tasks/{task_id}/status",
  HELP_MANUAL_UPLOAD: "/help/manual/upload",
  S3_PRESIGNED_UPLOAD_URL: "/s3/presigned-upload-url",
  HELP_MANUAL_DOWNLOAD: "/help/manual/download?jwt=",
  DASHBOARD_PENDING_TASKS: "/dashboard/pendingtasks",
  DASHBOARD_STOPWATCHS: "/dashboard/stopwatchs",
  DASHBOARD_CHILDREN_TASK: "/dashboard/pendingtasks/{taskId}/childs",
  HELP_HELP_CHAIN_INFO: "/help/manual/chain-info",
  GET_HELP_STORE_INFO: "/help/manual/store-info",
  NOTIFICATION: "/notifications",
  SET_IS_CHECK_NOTIFICATION: "/setchecknotification",
  SETSEENNOTIFI: "/seenNotifi",
  CHECK_NOTIFICATION: "/notifications",
  GANTT_CHART: "/ganttchart",
  HELP_MANUAL_FILE_DETAIL: "/help/manual/filedetail",
  HELP_MANUAL_FILE: "/help/manual/file",
  ADMIN_TASKLOGS: "/admin/tasklogs",
  TASKLOGS_TASKS: "/tasklogs/tasks",
  CREATE_OTA: "/ota",
  OTA_TYPES: "/otatypes",
  OTA_DETAIL_UPDATE: "/otas/{otaId}",
  OTA_UPDATE_STATUS: "/otas/{otaId}/status",
  UPDATE_STORE_OTA_EXPIRED_DATE: "/stores/{storeId}/otas/{otaId}/renewalPassDate",
  TASK_TEMPLATES: "/items",
  PLANS: "/plans",
  PLAN: "/plans/{planId}",
  ADD_PLAN: "/plan",
  PLAN_REORDER: "/plans/reorder",
  AMOUNT_GROUPS: "/amountgroups",
  AMOUNT_GROUP: "/amountgroups/{amountId}",
  ADD_AMOUNT_GROUP: "/amountgroup",
  AMOUNT_RANKS: "/amountranks",
  STORE_OTAS: "/stores/{storeId}/otas",
  STORE_BY_ID: "/store/{storeId}",
  AMOUNT_GROUPS_BY_STORE_IDS: "/amountgroups/storeids",
  OTA_BY_STORE_IDS: "/ota/storeids",
  EXPORT_TASKS_LIST: "/export",
  MEMBER_LIST: "/account/members",
  LIST_ALL_OTAS: "/otas/get-all",
  GET_SITE_CONTROLLERS: "/otas/site_controllers",
  CONTENT_LIST: "/content/get-list",
  CONTENT_SEARCH: "/content/search",
  CONTENT_BY_ID: "/content/{contentId}",
  CONTENT_RESUME: "/content/{contentId}/resume",
  CREATE_CONTENT: "content/create",
  TASK_CONTENTS: "/task-contents/{taskId}",
  TASK_CONTENTS_VIEW: "/task-contents/{taskId}/view",
  TASK_CONTENT_PLANS: "/task-content-plans/{taskId}",
  TASK_CONTENT_PLAN_COPY: "/task-content-plans/{taskId}/copy",
  TASK_CONTENT_TASKLOGS_LATEST: "/task-contents/{taskId}/tasklogs/latest",
  TASK_CONTENT_TOTAL_TIMES: "/task-contents/{taskId}/totaltimes",
  TASK_CONTENT_STOPWATCH: "/task-contents/{taskId}/stopwatch",
  MANUAL_DOWNLOAD: "/help/{helpId}/manual/download",
  HELP_REMOVE_MANUAL_FILE: "/help/{helpId}/manual/remove",
  HELP_SAVE_MANUAL: "/help/manual/save",
  TASK_ASSIGN: "/tasks/task-assign",
  TASK_ACHIEVEMENT: "/task-contents/task-achievement",
  TASK_ACHIEVEMENT_DOWNLOAD: "/task-contents/task-achievement/download",
  TASK_DELIVERY_ACHIEVEMENT: "/task/task-delivery-achievement",
  TASK_DELIVERY_ACHIEVEMENT_DOWNLOAD: "/task/task-delivery-achievement/download",
  TASK_ANALYSIS: "/task/task-analysis",
  CHANGE_TASK_FIXED_DEADLINE: "/task/change-fixed-deadline",
  TEAM_ACHIEVEMENT: "/team/team-achievement",
  TEAM_ACHIEVEMENT_DOWNLOAD: "/team/team-achievement/download",
  CONTENT_ACHIEVEMENT: "/task-contents/task-content-achievement",
  CONTENT_ACHIEVEMENT_DOWNLOAD: "/task-contents/task-content-achievement/download",
  TEAM_CONTENT_ACHIEVEMENT: "/team/team-content-achievement",
  TEAM_CONTENT_ACHIEVEMENT_DOWNLOAD: "/team/team-content-achievement/download",
  EXPORTED_CONTENTS_PLAN_SEARCH: "/exported-contents/plan/search",
  EXPORTED_CONTENTS_PLAN_EXPORT_ROWS: "/exported-contents/plan/export-rows",
  EXPORTED_CONTENTS_EXECUTION_SEARCH: "/exported-contents/execution/search",
  EXPORTED_CONTENTS_EXECUTION_EXPORT_ROWS: "/exported-contents/execution/export-rows",
  TASK_COPY_HISTORY_SEARCH: "/task-copy-history/search",
  LIST_STORES: "/task-store/stores",
  TASK_STORE_STATISTIC_DOWNLOAD: "/task-store/statistic/download",
  TASK_STORE_CONFIG: "/task-store-config/{storeId}/{isStore}",
  TASK_STORE_CONFIG_ADD_AND_EDIT: "/task-store-config/add-and-edit",
  TASK_STORE_CONFIG_DELETE: "/task-store-config/delete/{storeId}/{isStore}",
  HELP_AGGREGATE_RANKING_HOTEL: "/aggregate/ranking",
  HELP_DOWNLOAD_RANKING_REPORT: "/aggregate/ranking/downloadReport",
  HELP_DOWNLOAD_CRON_RANKING_REPORT: "/aggregate/ranking-cron/downloadReport",
  HELP_GET_RANKING_FILE_REPORT: "/aggregate/ranking/getReport",
  HELP_GET_CRON_RANKING_FILE_REPORT: "/aggregate/ranking-cron/getReport",
  CREATE_CRON_RANKING_FILE_REPORT: "/aggregate/ranking/create-cron",
  GET_CRON_RANKING_FILE_REPORT: "auto-crawl-aggregate/get-data",
  CRAWL_PLAN_SALE: "/crawl-plan-sale",
  CRAWL_PLAN_SALE_DOWNLOAD: "/crawl-plan-sale/download",
  GET_CRAWL_PLAN_SALE: "/crawl-plan-sale/current",
  CRAWL_PLAN_RESULT: "/crawl-plan-result",
  GET_CRAWL_PLAN_RESULT: "/crawl-plan-result/current",
  CRAWL_COUPON: "/crawl-coupon",
  GET_CRAWL_COUPON: "/crawl-coupon/current",
  CRAWL_COUPON_MEASUREMENT: "/crawl-coupon-measurement",
  GET_CRAWL_COUPON_MEASUREMENT: "/crawl-coupon-measurement/current",
  CRAWL_COUPON_DOWNLOAD: "/crawl-coupon/download",
  CRAWL_SALE_STATISTIC: "/crawl-sale-statistic",
  GET_CRAWL_SALE_STATISTIC: "/crawl-sale-statistic/current",
  CREATE_REQUEST_TIME: "/request-time/create",
  DELETE_REQUEST_TIME: "/request-time/delete/{requestTimeId}",
  LIST_REQUEST_TIME: "/request-time",
  LIST_TOTAL_TIME_WORK: "/total-time-work",
  LIST_TIMESHEET: "/timesheet",
  SAVE_TIMESHEET: "/timesheet/save",
  LIST_RESOURCE_SHEET: "/resource-sheet",
  SAVE_RESOURCE_SHEET: "/resource-sheet/save",
  LIST_RESOURCE_SHEET_EDIT_LOG: "/resource-sheet/edit-logs",
  RESOURCE_DASHBOARD: "/resource-dashboard",
  CRAWL_PRINCE_ACHIEVEMENT: "/crawl-prince-achievement",
  GET_CRAWL_PRINCE_ACHIEVEMENT: "/crawl-prince-achievement/current",
  SAVE_DATA_AUTO_CRAWL_COUPON: "/auto-crawl-coupon/save-data",
  AUTO_CRAWL_COUPON: "/auto-crawl-coupon/get-data",
  ADD_SEARCH_CONDITION: "/tasks/save-search",
  GET_SEARCH_CONDITION: "/tasks/get-search",
  GET_SEARCH_CONDITIONS_LIST: "/tasks/search-conditions",
  DELETE_SEARCH_CONDITION: "/tasks/search-conditions/{id}",
  GET_TEMPLATE: "/template/{categoryId}",
  GET_TEMPLATE_BY_SUB_CATEGORY: "/template/sub-category/{subCategoryId}",
  AUTO_COPY_TASK_SEARCH: "/auto-copy-task/search",
  CREATE_AUTO_COPY_TASK: "/auto-copy-task/create",
  DETAIL_AUTO_COPY_TASK: "/auto-copy-task/get-cronjob/{autoCopyTaskId}",
  UPDATE_AUTO_COPY_TASK: "/auto-copy-task/update/{autoCopyTaskId}",
  ROOM_SEARCH: "/room-ota",
  GET_LIST_API_PLAN: "/api-plan-ota/search",
  GET_LIST_API_CATEGORY: "/api-image-category/get-all",
  API_IMAGE: "/api-image-ota",
  API_IMAGE_SEARCH: "/api-image-ota/search",
  API_IMAGE_DELETE: "/api-image-ota/delete/{apiImageOtaId}",
  CREATE_API_IMAGE_CATEGORY: "/api-image-category/create",
  API_IMAGE_CATEGORY_ID: "/api-image-category/{imageCategoryId}",
  API_IMAGE_CATEGORY_SEARCH: "/api-image-category",
  LIST_ALL_API_OTAS: "/api-otas/get-all",
  GET_API_PLAN_DETAIL: "/api-plan-ota/{planId}/get",
  DELETE_API_PLAN_OTA: "/api-plan-ota/{apiPlanOtaId}/api-plan/{apiPlanId}/delete",
  ADD_API_PLAN: "/api-plan/create",
  UPDATE_API_PLAN: "/api-plan/{apiPlanId}/update",
  SELECT_API_ROOMS: "/select-api-rooms",
  API_IMAGE_BY_STORE_AND_OTA: "/api-image-ota-by-store-and-ota",
  CREATE_ROOM: "/rooms/create",
  ROOM_DETAIL_UPDATE: "/rooms/{apiRoomId}",
  DELETE_API_ROOM_OTA: "/room-ota/{apiRoomOtaId}/room/{apiRoomId}/delete",
  SYNC_ROOM_OTA: "/room-ota/sync/{apiRoomOtaId}",
  GET_API_OPTION_VALUES: "/api-option-values",
  API_IMAGE_STORE_AND_OTA: "/api-image-ota-store-and-ota",
  SYNC_PLAN_OTA: "/api-plan-ota/sync/{apiPlanOtaId}",
  CRAWL_ROOM_SEARCH: "/crawl-room/search",
  CRAWL_ROOM: "/crawl-room",
  CRAWL_ROOM_ALL: "/crawl-room-all",
  CRAWL_ROOM_DETAILS: "/crawl-room-details",
  CRAWL_ROOM_DOWNLOAD_EXCEL: "/crawl-room/download-excel/{apiCrawlRoomDataId}/{typeDownload}",
  CRAWL_ROOM_IMPORT_EXCEL: "/crawl-room/import-excel/{apiCrawlRoomDataId}",
  DELETE_API_CATEGORY: "/api-image-category/delete/{apiCategoryId}",
  CRAWL_PLAN_SEARCH: "/crawl-plan/search",
  CRAWL_PLAN: "/crawl-plan",
  CRAWL_PLAN_DOWNLOAD_EXCEL: "/crawl-plan/download-excel/{apiCrawlPlanDataId}/{typeDownload}",
  CRAWL_PLAN_IMPORT_EXCEL: "/crawl-plan/import-excel/{apiCrawlPlanDataId}",
  CRAWL_DATA_CANCEL_POLICY: "/crawl-cancel-policy",
  GET_CANCEL_POLICY: "/get-cancel-policy",
  GET_SYNC_PLAN_STATUS: "/api-plan-ota/sync/status",
  UPDATE_ROOM_OTA: "/room-ota/update/{apiRoomOtaId}",
  UPDATE_PLAN_OTA: "/plan-ota/update/{apiPlanOtaId}",
  CRAWL_ALL_PLAN: "/crawl-all-plan",
  UPDATE_MULTIPLE_PLAN_OTA: "/plan-ota/update-multiple",
  OPEN_SALE_ROOM: "/room/open-sale",
  STOP_SELLING_ROOM: "/room/stop-selling",
  OPEN_SALE_PLAN: "/plan-ota/open-sale",
  STOP_SELLING_PLAN: "/plan-ota/stop-selling",
  TASK_EXTRA_ATTACH_UPLOAD: "/tasks/extra-attach/upload",
  REQUEST_CODE_AUTHENTICATION: "/request-authentication",
  UPDATE_CODE_AUTHENTICATION: "/update-authentication",
  GET_INFO_AUTHENTICATION_CURRENT: "/request-authentication/current",
  CRAWL_VISITOR_TO_HENNA_HOTEL: "/crawl-visitor-henna-hotel",
  AUTO_CRAWL: "/auto-crawl/get-data",
  SAVE_DATA_AUTO_CRAWL: "/auto-crawl/save-data",
  GET_CRAWL_VISITOR_TO_HENNA_HOTEL: "/crawl-visitor-henna-hotel/current",
  CRAWL_ADDITIONAL_REQUEST: "/crawl-additional-request",
  GET_CRAWL_ADDITIONAL_REQUEST: "/crawl-additional-request/current",
  CREATE_WORK_SHEET: "/tasks/create-work-sheet/{taskId}",
  GET_OPTION: "/get-option",
  CRAWL_OPTION: "/crawl-option",
  CRAWL_DATA_COLLECTION: "/crawl-data-collection",
  GET_CRAWL_DATA_COLLECTION: "/crawl-data-collection/current",
  PLAN_LINK_PRICES: "/api-plan-ota-link-price",
  DELETE_STORE_BY_ID: "/store/delete/{storeId}",
  CRAWL_RANKING_AND_SCORE: "/crawl-ranking-score",
  GET_CRAWL_RANKING_AND_SCORE: "/crawl-ranking-score/current",
  IMPORT_INFORMATION_STORES: "/crawl-ranking-score/import-information-store",
  DOWNLOAD_INFORMATION_STORES: "/crawl-ranking-score/download-information-store",
  DELETE_INFORMATION_STORES: "/crawl-ranking-score/delete-information-store",
  GET_INFORMATION_STORES: "/crawl-ranking-score/get-information-store",
  TEAM_SEARCH: "/team/search",
  CREATE_TEAM: "/team/create",
  DETAIL_TEAM: "/team/detail/{teamId}",
  UPDATE_TEAM: "/team/update/{teamId}",
  DELETE_TEAM: "/team/delete/{teamId}",
  GET_PARENT_TEAMS: "/team/parent-teams",
  GET_TEAM_OPTIONS: "/team/options",
  GET_PERSON_IN_CHARGE: "/person_in_charge",
  GET_ACCOUNT_BY_STORE: "/store/{storeId}/accounts",
  DOWNLOAD_TOTAL_TIME_WORK: "/total-time-work/download",
  DOWNLOAD_DAILY_WORK_SUMMARY: "/daily-work-summary/download",
  INFORMATION_STORES_BOOKING_POSITION: "/crawl-booking-position/import-information-store",
  DOWNLOAD_INFORMATION_STORES_BOOKING_POSITION: "/crawl-booking-position/download-information-store",
  DELETE_INFORMATION_STORES_BOOKING_POSITION: "/crawl-booking-position/delete-information-store",
  CRAWL_BOOKING_POSITION: "/crawl-booking-position",
  GET_CRAWL_BOOKING_POSITION: "/crawl-booking-position/current",
  GET_EXCEL_BOOKING_POSITION: "/crawl-booking-position/get-information-store",
  CRAWL_DOMESTIC_INDICATOR: "/crawl-domestic-indicator",
  GET_CRAWL_DOMESTIC_INDICATOR: "/crawl-domestic-indicator/current",
  GET_EXCEL_DOMESTIC_INDICATOR: "/crawl-domestic-indicator/get-information-store",
  DELETE_INFORMATION_STORES_DOMESTIC_INDICATOR: "/crawl-domestic-indicator/delete-information-store",
  INFORMATION_STORES_DOMESTIC_INDICATOR: "/crawl-domestic-indicator/import-information-store",
  DOWNLOAD_INFORMATION_STORES_DOMESTIC_INDICATOR: "/crawl-domestic-indicator/download-information-store",
  CRAWL_EXTRACT_SELLING_PRICE: "/crawl-extract-selling-price",
  GET_CRAWL_EXTRACT_SELLING_PRICE: "/crawl-extract-selling-price/current",
  CRAWL_EXTRACT_SELLING_PRICE_DOWNLOAD: "/crawl-extract-selling-price/download/{type}",
  UPDATE_FORMULA_DOMESTIC_INDICATOR: "/update-formula-domestic-indicator",
  CRAWL_RANKING_AND_SCORE_CRON: "/crawl-ranking-score/cron",
  GET_RANKING_AND_SCORE_CRON: "/auto-crawl-ranking-score/get-data",
  TASK_ATTACH_FILE_COMMENT: "/tasks/attach/upload-file-comment",
  GET_TASK_ATTACH_FILE_COMMENT: "/tasks/attach/get-file-comments/{taskId}",
  DELETE_TASK_ATTACH_FILE_COMMENT: "/tasks/{taskId}/attach/delete-file-comment/{taskAttachId}",
  TEAM_SETTINGS_LIST: "/teams/settings",
  TEAM_SETTINGS_UPSERT: "/teams/settings",
  TEAM_SETTINGS_TOGGLE: "/teams/settings/{teamWorkSheetSettingId}/toggle-sync",
  TEAM_SETTINGS_BULK_SYNC: "/teams/settings/{teamWorkSheetSettingId}/bulk-sync",
  TEAM_SETTINGS_CLEAR: "/teams/settings/{teamWorkSheetSettingId}/clear",
  TEAM_SETTINGS_DELETE: "/teams/settings/{teamWorkSheetSettingId}",
  TEAM_SETTINGS_SYNC_ERRORS: "/teams/settings/{teamWorkSheetSettingId}/sync-errors",
  TEAM_SETTINGS_SYNC_ERRORS_EXPORT: "/teams/settings/{teamWorkSheetSettingId}/sync-errors/export",
  FETCH_ALL_TASK_STATUS: "/task/statuses",
  FETCH_TASK_STATUS_BY_SCREEN: "/task/status/screen",
  CRAWLING_SETTINGS_SEARCH: "/crawling-settings/search",
  CRAWLING_SETTINGS_CREATE: "/crawling-settings/create",
  CRAWLING_SETTINGS_VALIDATE_SETTING_FILE: "/crawling-settings/validate-setting-file",
  CRAWLING_SETTINGS_DETAIL: "/crawling-settings/{crawlingSettingId}",
  CRAWLING_SETTINGS_UPDATE: "/crawling-settings/update/{crawlingSettingId}",
  CRAWLING_SETTINGS_DELETE: "/crawling-settings/delete/{crawlingSettingId}",
  CRAWLING_SETTINGS_EXECUTE: "/crawling-settings/{crawlingSettingId}/execute",
  CRAWLING_SETTINGS_CANCEL: "/crawling-settings/{crawlingSettingId}/cancel",
  CRAWLING_SETTINGS_CURRENT: "/crawling-settings/{crawlingSettingId}/current",
  CRAWLING_SETTINGS_HISTORIES: "/crawling-settings/{crawlingSettingId}/histories",
  CRAWLING_SETTINGS_IMPORT: "/crawling-settings/import/{crawlingSettingId}",
  CRAWLING_SETTINGS_IMPORT_SETTING_FILE: "/crawling-settings/import-setting-file",
  CRAWLING_SETTINGS_DOWNLOAD_SETTING_FILE_DRAFT:
    "/crawling-settings/download-setting-file",
  CRAWLING_SETTINGS_DELETE_SETTING_FILE_DRAFT:
    "/crawling-settings/delete-setting-file",
  CRAWLING_SETTINGS_GET_SETTING_FILE: "/crawling-settings/get-setting-file",
  CRAWLING_SETTINGS_DOWNLOAD_SETTING_FILE: "/crawling-settings/{crawlingSettingId}/download-setting-file",
  CRAWLING_SETTINGS_HISTORY_DOWNLOAD: "/crawling-settings/history/{historyId}/download",
  CRAWLING_SETTINGS_DOWNLOAD_LATEST: "/crawling-settings/{crawlingSettingId}/download-latest",

  REVIEW_CRAWLING_SETTING_SEARCH: "/review-crawling-setting/search",
  REVIEW_CRAWLING_SETTING_CREATE: "/review-crawling-setting/create",
  REVIEW_CRAWLING_SETTING_VALIDATE_SETTING_FILE:
    "/review-crawling-setting/validate-setting-file",
  REVIEW_CRAWLING_SETTING_DETAIL: "/review-crawling-setting/{reviewCrawlingSettingId}",
  REVIEW_CRAWLING_SETTING_UPDATE:
    "/review-crawling-setting/update/{reviewCrawlingSettingId}",
  REVIEW_CRAWLING_SETTING_DELETE:
    "/review-crawling-setting/delete/{reviewCrawlingSettingId}",
  REVIEW_CRAWLING_SETTING_EXECUTE:
    "/review-crawling-setting/{reviewCrawlingSettingId}/execute",
  REVIEW_CRAWLING_SETTING_CANCEL:
    "/review-crawling-setting/{reviewCrawlingSettingId}/cancel",
  REVIEW_CRAWLING_SETTING_CURRENT:
    "/review-crawling-setting/{reviewCrawlingSettingId}/current",
  REVIEW_CRAWLING_SETTING_RUNS:
    "/review-crawling-setting/{reviewCrawlingSettingId}/runs",
  REVIEW_CRAWLING_SETTING_IMPORT:
    "/review-crawling-setting/import/{reviewCrawlingSettingId}",
  REVIEW_CRAWLING_SETTING_IMPORT_SETTING_FILE:
    "/review-crawling-setting/import-setting-file",
  REVIEW_CRAWLING_SETTING_DOWNLOAD_SETTING_FILE_DRAFT:
    "/review-crawling-setting/download-setting-file",
  REVIEW_CRAWLING_SETTING_DELETE_SETTING_FILE_DRAFT:
    "/review-crawling-setting/delete-setting-file",
  REVIEW_CRAWLING_SETTING_GET_SETTING_FILE: "/review-crawling-setting/get-setting-file",
  REVIEW_CRAWLING_SETTING_DOWNLOAD_SETTING_FILE:
    "/review-crawling-setting/{reviewCrawlingSettingId}/download-setting-file",
  REVIEW_CRAWLING_SETTING_RUN_DOWNLOAD:
    "/review-crawling-setting/runs/{runId}/download",
  REVIEW_CRAWLING_SETTING_DOWNLOAD_LATEST:
    "/review-crawling-setting/{reviewCrawlingSettingId}/download-latest",

  TLL_BULK_RESERVATION_SETTINGS_LIST: "/tll-bulk-reservation-settings",
  TLL_BULK_RESERVATION_SETTINGS_SEARCH: "/tll-bulk-reservation-settings/search",
  TLL_BULK_RESERVATION_SETTINGS_CREATE: "/tll-bulk-reservation-settings/create",
  TLL_BULK_RESERVATION_SETTINGS_DETAIL:
    "/tll-bulk-reservation-settings/{batchCrawlSettingId}",
  TLL_BULK_RESERVATION_SETTINGS_UPDATE:
    "/tll-bulk-reservation-settings/update/{batchCrawlSettingId}",
  TLL_BULK_RESERVATION_SETTINGS_DELETE:
    "/tll-bulk-reservation-settings/delete/{batchCrawlSettingId}",
  TLL_BULK_RESERVATION_SETTINGS_EXECUTE:
    "/tll-bulk-reservation-settings/{batchCrawlSettingId}/execute",
  TLL_BULK_RESERVATION_SETTINGS_CANCEL:
    "/tll-bulk-reservation-settings/{batchCrawlSettingId}/cancel",
  TLL_BULK_RESERVATION_SETTINGS_CURRENT:
    "/tll-bulk-reservation-settings/{batchCrawlSettingId}/current",
  TLL_BULK_RESERVATION_SETTINGS_HISTORIES:
    "/tll-bulk-reservation-settings/{batchCrawlSettingId}/histories",
  TLL_BULK_RESERVATION_SETTINGS_RUN_DOWNLOAD:
    "/tll-bulk-reservation-settings/runs/{batchCrawlRunId}/download",
  TLL_BULK_RESERVATION_SETTINGS_DOWNLOAD_LATEST:
    "/tll-bulk-reservation-settings/{batchCrawlSettingId}/download-latest",

  RAKUTEN_SCORING_SETTINGS_SEARCH: "/rakuten-scoring-settings/search",
  RAKUTEN_SCORING_SETTINGS_DELETE:
    "/rakuten-scoring-settings/delete/{batchCrawlSettingId}",
  RAKUTEN_SCORING_SETTINGS_DOWNLOAD_LATEST:
    "/rakuten-scoring-settings/{batchCrawlSettingId}/download-latest",
  RAKUTEN_SCORING_SETTINGS_CREATE: "/rakuten-scoring-settings/create",
  RAKUTEN_SCORING_SETTINGS_DETAIL: "/rakuten-scoring-settings/{batchCrawlSettingId}",
  RAKUTEN_SCORING_SETTINGS_UPDATE: "/rakuten-scoring-settings/update/{batchCrawlSettingId}",
  RAKUTEN_SCORING_SETTINGS_DOWNLOAD_SETTING_FILE:
    "/rakuten-scoring-settings/{batchCrawlSettingId}/download-setting-file",
  RAKUTEN_SCORING_SETTINGS_EXECUTE:
    "/rakuten-scoring-settings/{batchCrawlSettingId}/execute",
  RAKUTEN_SCORING_SETTINGS_CANCEL:
    "/rakuten-scoring-settings/{batchCrawlSettingId}/cancel",
  RAKUTEN_SCORING_SETTINGS_CURRENT:
    "/rakuten-scoring-settings/{batchCrawlSettingId}/current",
  RAKUTEN_SCORING_SETTINGS_HISTORIES:
    "/rakuten-scoring-settings/{batchCrawlSettingId}/histories",
  RAKUTEN_SCORING_SETTINGS_RUN_DOWNLOAD:
    "/rakuten-scoring-settings/runs/{batchCrawlRunId}/download",

  SLACK_MEETING_STORE_MAPPINGS_SEARCH: "/slack-meeting-store-mappings/search",
  SLACK_MEETING_STORE_MAPPING_DETAIL:
    "/slack-meeting-store-mappings/{slackMeetingStoreMappingId}",
  SLACK_MEETING_STORE_MAPPING_CREATE: "/slack-meeting-store-mapping",
  SLACK_MEETING_STORE_MAPPING_UPDATE:
    "/slack-meeting-store-mappings/{slackMeetingStoreMappingId}",
  SLACK_MEETING_STORE_MAPPING_DELETE:
    "/slack-meeting-store-mappings/{slackMeetingStoreMappingId}",

  GALLERY_CONTENT_SEARCH: "/gallery-content/search",
  GALLERY_CONTENT_DETAIL: "/gallery-content/{galleryContentStoreId}",
  GALLERY_CONTENT_REGISTER: "/gallery-content/register",
  GALLERY_CONTENT_UPDATE: "/gallery-content/{galleryContentStoreId}",
  GALLERY_CONTENT_DELETE: "/gallery-content/{galleryContentStoreId}",
  GALLERY_CONTENT_STORES_FOR_SELECT: "/gallery-content/stores-for-select",
  GALLERY_CONTENT_EXECUTE: "/gallery-content/execute",
  GALLERY_CONTENT_EXPORT: "/gallery-content/{galleryContentStoreId}/export",

  PROPOSAL_SLIDE_SETTINGS_SEARCH: "/proposal-slide-settings/search",
  PROPOSAL_SLIDE_SETTINGS_CREATE: "/proposal-slide-settings",
  PROPOSAL_SLIDE_SETTING_DETAIL: "/proposal-slide-settings/{proposalSlideSettingId}",
  PROPOSAL_SLIDE_SETTING_UPDATE: "/proposal-slide-settings/{proposalSlideSettingId}",
  PROPOSAL_SLIDE_SETTING_DELETE: "/proposal-slide-settings/{proposalSlideSettingId}",
  PROPOSAL_SLIDE_SETTING_EXECUTE: "/proposal-slide-settings/{proposalSlideSettingId}/execute",

  FACILITY_CREDENTIAL_SEARCH: "/facility-credentials/search",
  FACILITY_CREDENTIAL_CREATE: "/facility-credentials",
  FACILITY_CREDENTIAL_DETAIL: "/facility-credentials/{facilityCredentialId}",
  FACILITY_CREDENTIAL_UPDATE: "/facility-credentials/{facilityCredentialId}",
  FACILITY_CREDENTIAL_DELETE: "/facility-credentials/{facilityCredentialId}",
  FACILITY_CREDENTIAL_RENEW_PROFILE_OTA:
    "/facility-credentials/{facilityCredentialId}/otas/{otaId}/renewalPassDate",
  FACILITY_CREDENTIAL_MERGED_STORE_OTAS: "/facility-credentials/merged-store-otas",
  FACILITY_CREDENTIAL_LINKED_STORES: "/facility-credentials/linked-stores",
  FACILITY_CREDENTIAL_FOR_CRAWL_SELECT: "/facility-credentials/for-crawl-select",
  AI_CHECK_LIST: "ai-check/list",
  AI_CHECK_CREATE: "ai-check/create",
  AI_CHECK_LINKED_TASK: "ai-check/linked-task",
  AI_CHECK_NORMALIZE: "ai-check/normalize",
  AI_CHECK_DETAIL: "ai-check/{executionId}",
  AI_CHECK_PROMOTION_PLAN_DETAIL: "ai-check/{executionId}/plan/{planId}",
  AI_CHECK_CRAWL_DATA_EXPORT: "/ai-check/{executionId}/crawl-data/export",
  AI_CHECK_KNOWLEDGE_DB_LIST: "ai-check/knowledge-db/list",
};

export const ENDPOINTS_WITHOUT_AUTHEN = [
  API_ENDPOINTS.LOGIN,
  API_ENDPOINTS.RESET_PASS,
  API_ENDPOINTS.ACCOUNT_PASSWORD,
  API_ENDPOINTS.CONFIRM_EMAIL,
];
